/** 专业剧本编辑器 · 元素类型 */

export type ScriptElementType =
  | 'scene_heading'
  | 'action'
  | 'character'
  | 'parenthetical'
  | 'dialogue'
  | 'transition'
  | 'shot'
  | 'note'

export interface ScriptElement {
  id: string
  type: ScriptElementType
  content: string
  sceneNo?: number
}

let scriptElementSeq = 0

export function newScriptElementId(): string {
  scriptElementSeq += 1
  return `sel-${Date.now().toString(36)}-${scriptElementSeq}`
}

export function createScriptElement(
  type: ScriptElementType,
  content = '',
  sceneNo?: number,
): ScriptElement {
  return { id: newScriptElementId(), type, content, sceneNo }
}

export const ELEMENT_META: Record<
  ScriptElementType,
  { label: string; short: string; hint: string; color: string }
> = {
  scene_heading: {
    label: '场景标题',
    short: '场景',
    hint: 'Tab · 例：内景 公寓客厅 - 夜',
    color: '#818cf8',
  },
  action: {
    label: '动作',
    short: '动作',
    hint: '场景描述与人物动作',
    color: '#a1a1aa',
  },
  character: {
    label: '角色',
    short: '角色',
    hint: '对白说话人 · 居中',
    color: '#fbbf24',
  },
  parenthetical: {
    label: '括号',
    short: '括号',
    hint: '语气/动作提示 · (低声)',
    color: '#fb923c',
  },
  dialogue: {
    label: '对白',
    short: '对白',
    hint: 'Enter 结束对白 → 动作行',
    color: '#34d399',
  },
  transition: {
    label: '转场',
    short: '转场',
    hint: '切至： / FADE OUT.',
    color: '#c084fc',
  },
  shot: {
    label: '镜头',
    short: '镜头',
    hint: '镜头提示 · 推/拉/摇',
    color: '#38bdf8',
  },
  note: {
    label: '编剧注释',
    short: '注释',
    hint: '不导出 · 仅协作可见',
    color: '#71717a',
  },
}

export const ELEMENT_ORDER: ScriptElementType[] = [
  'scene_heading',
  'action',
  'character',
  'parenthetical',
  'dialogue',
  'transition',
  'shot',
  'note',
]

/** 删除/增删场标题后，按文档顺序重算各元素所属场次 */
export function reassignSceneNos(elements: ScriptElement[]): ScriptElement[] {
  let sceneNo = 0
  return elements.map((el) => {
    if (el.type === 'scene_heading') {
      sceneNo += 1
      const m = el.content.match(/^(\d+)\./)
      if (m) sceneNo = Number.parseInt(m[1]!, 10) || sceneNo
      return { ...el, sceneNo }
    }
    return { ...el, sceneNo: sceneNo || 1 }
  })
}
